import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { StaffPageContent } from '@/components/admin/staff';

// This non-finance /admin surface is TeamManagement-only. The /admin shell now
// also admits Finance:View (so those users reach the finance area), so each
// non-finance child must re-assert its own capability — otherwise a Finance:View
// user could reach it by URL. TeamManagement:View is exactly what the /admin
// parent required before, so this is behavior-preserving for existing users.
export const Route = createFileRoute('/admin/staff')({
  beforeLoad: ({ context }) => {
    requireCapability(context, 'TeamManagement', CapabilityTier.View, '/admin/staff');
  },
  component: StaffPage,
});

function StaffPage() {
  return <StaffPageContent />;
}
